import { render, staticRenderFns } from "./LinkUser.vue?vue&type=template&id=931faf3a"
import script from "./LinkUser.vue?vue&type=script&lang=js"
export * from "./LinkUser.vue?vue&type=script&lang=js"
import style0 from "./LinkUser.vue?vue&type=style&index=0&id=931faf3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports